// extracted by mini-css-extract-plugin
var _1 = "ad-group-column___corQb";
var _2 = "bulk-edit-row___ua1xG";
var _3 = "empty-table-text___qV7Vs";
var _4 = "field___IGiFO";
var _5 = "header-label___q2GRt";
var _6 = "match-type-column___vxUIs";
var _7 = "remove-column___THzg6";
export { _1 as "ad-group-column", _2 as "bulk-edit-row", _3 as "empty-table-text", _4 as "field", _5 as "header-label", _6 as "match-type-column", _7 as "remove-column" }
